import { isMockMode, post, simulateDelay } from "../api";

export const addInstaller = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Products/AddInstaller`, data, {
		successMessage: "Installer successfully added",
	});
};
